import Button from '@mui/material/Button';
import {withStyles} from '@mui/styles';

const FormButton = withStyles(theme => ({
    root: {
        boxShadow: 'none !important',
        textTransform: 'none !important',
        fontSize: '1rem !important',
        fontWeight: 600,
        padding: '2px 12px !important',
        borderRadius: '4px !important',
        border: '3px solid !important',
        borderColor: '#004C6A !important',
        lineHeight: '1.5 !important',
        transition: 'all 0.3s ease !important',
        '&:hover': {
            border: '2px solid !important',
            borderColor: '#004C6A !important',
            transform: 'translateY(-1px)',
            boxShadow: '0 2px 8px rgba(0, 76, 106, 0.2) !important',
        },
    },
    outlined: {
        backgroundColor: 'white !important',
        color: '#004C6A !important',
        border: '2px solid',
        borderColor: '#004C6A !important',
        '&:hover': {
            backgroundColor: 'rgba(0, 76, 106, 0.04) !important',
            border: '2px solid',
            borderColor: '#004C6A !important',
        },
    },
    contained: {
        backgroundColor: '#004C6A !important',
        color: 'white !important',
        border: '2px solid',
        borderColor: '#004C6A !important',
        '&:hover': {
            backgroundColor: '#003D56 !important',
            border: '2px solid',
            borderColor: '#003D56 !important',
        },
    },
}))(Button);


export default FormButton;